<template>
    <v-card class="pa-3 ma-3">
        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-card-account-details-outline</v-icon
            >
            <pre><v-toolbar-title><h2 style="margin-left:20px;"> Lista de fichajes</h2></v-toolbar-title></pre>
        </v-toolbar>
        <loader v-if="isloading"></loader>
        <v-tooltip right v-if="admin">
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="
                        dialog = true;
                        fichaje = {};
                    "
                    :loading="isloading"
                    :disabled="isloading"
                    color="success"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-plus</v-icon>
                </v-btn>
            </template>
            <span>Crear</span>
        </v-tooltip>
        <v-row style="margin-bottom: 15px; margin-top: 15px">
            <v-col cols="12" md="3" v-if="admin">
                <v-autocomplete
                    hide-details
                    v-model="filtros.usuario"
                    :items="usuarios"
                    item-text="name"
                    item-value="id"
                    label="Usuarios"
                ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="3">
                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="filtros.fecha_inicio"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="filtros.fecha_inicio"
                            label="Fecha de inicio"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                        >
                        </v-text-field>
                    </template>
                    <v-date-picker
                        color="#1d2735"
                        first-day-of-week="1"
                        v-model="filtros.fecha_inicio"
                        no-title
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="menu = false"
                            ><strong>Cancelar</strong></v-btn
                        >
                        <v-btn
                            text
                            color="success"
                            @click="$refs.menu.save(filtros.fecha_inicio)"
                            ><strong>OK</strong></v-btn
                        >
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" md="3">
                <v-menu
                    ref="menu2"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :return-value.sync="filtros.fecha_fin"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="filtros.fecha_fin"
                            label="Fecha de fin"
                            append-icon="mdi-calendar"
                            v-bind="attrs"
                            v-on="on"
                        >
                        </v-text-field>
                    </template>
                    <v-date-picker
                        color="#1d2735"
                        first-day-of-week="1"
                        v-model="filtros.fecha_fin"
                        no-title
                        scrollable
                    >
                        <v-spacer></v-spacer>
                        <v-btn text color="red" @click="menu2 = false"
                            ><strong>Cancelar</strong></v-btn
                        >
                        <v-btn
                            text
                            color="success"
                            @click="$refs.menu2.save(filtros.fecha_fin)"
                            ><strong>OK</strong></v-btn
                        >
                    </v-date-picker>
                </v-menu>
            </v-col>
            <v-col cols="12" sm="3">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="filtrar"
                            :loading="isloading"
                            :disabled="isloading"
                            color="primary"
                            class="mt-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text">mdi-filter</v-icon>
                        </v-btn>
                    </template>
                    <span>Filtrar</span>
                </v-tooltip>
            </v-col>
        </v-row>
        <v-row> </v-row>
        <v-row>
            <v-col cols="12" md="4">
                <v-text-field
                    prepend-icon="mdi-account-search"
                    v-model="search"
                    label="Buscar"
                ></v-text-field>
            </v-col>
            <v-col cols="12" sm="3">
                <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            fab
                            @click="crearPDF"
                            :loading="isloading"
                            :disabled="isloading"
                            color="primary"
                            class="mt-2 mx-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            <v-icon class="white--text">mdi-file-pdf</v-icon>
                        </v-btn>
                    </template>
                    <span>PDF</span>
                </v-tooltip>
            </v-col>
            <v-col cols="12" sm="9" style="text-align: right" v-if="admin">
                <div style="display: flex; justify-content: end">
                    <v-card
                        elevation="2"
                        shaped
                        color="#851e31"
                        width="170"
                        height="70"
                        class="my-5 mx-2"
                    >
                        <v-card-text class="text-center white--text">
                            <p
                                class="font-weight-bold"
                                style="margin-bottom: -4px"
                            >
                                Horas trabajadas
                            </p>
                            {{ horas_trabajadas.toFixed(2) | horas_to_form }}
                        </v-card-text>
                    </v-card>

                    <template>
                        <v-card
                            elevation="2"
                            shaped
                            color="#1E1E1E"
                            width="170"
                            height="70"
                            class="my-5 mx-2"
                        >
                            <v-card-text class="text-center white--text">
                                <p
                                    class="font-weight-bold"
                                    style="margin-bottom: -4px"
                                >
                                    Horas jornada
                                </p>
                                {{ horas_semana.toFixed(2) | horas_to_form }}
                            </v-card-text>
                        </v-card>
                        <v-card
                            elevation="2"
                            shaped
                            color="#851e31"
                            width="170"
                            height="70"
                            class="my-5 mx-2"
                        >
                            <v-card-text class="text-center white--text">
                                <p
                                    class="font-weight-bold"
                                    style="margin-bottom: -4px"
                                >
                                    Horas nocturnas
                                </p>
                                {{ horas_extra.toFixed(2) | horas_to_form }}
                            </v-card-text>
                        </v-card>
                        <v-card
                            elevation="2"
                            shaped
                            color="#1E1E1E"
                            width="170"
                            height="70"
                            class="my-5 mx-2"
                        >
                            <v-card-text class="text-center white--text">
                                <p
                                    class="font-weight-bold"
                                    style="margin-bottom: -4px"
                                >
                                    Pago nocturno
                                </p>
                                {{ pago_extra | format_precio }}
                            </v-card-text>
                        </v-card>
                        <v-card
                            @click="openConsumoModal"
                            v-if="consumo != null"
                            elevation="2"
                            shaped
                            color="#851e31"
                            width="170"
                            height="70"
                            class="my-5 mx-2"
                        >
                            <v-card-text class="text-center white--text">
                                <p
                                    class="font-weight-bold"
                                    style="margin-bottom: -4px"
                                >
                                    Consumo
                                </p>
                                {{ consumo.total.toFixed(2) }}
                            </v-card-text>
                        </v-card>
                    </template>
                </div>
            </v-col>
        </v-row>
        <v-data-table
            dense
            :headers="headers"
            :items="fichajes"
            :search="search"
            :item-class="getRowClass"
            :expanded.sync="expanded"
            item-key="id_0"
            class="elevation-1"
            :sort-by="['nombre']"
            :sort-desc="[false]"
            single-expand
            show-expand
        >
            <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" v-if="item.orden">
                    <table>
                        <tr>
                            <th style="padding-right: 1rem">Obra</th>
                            <th>Fichaje</th>
                        </tr>
                        <template v-for="(ordenes, key) in item.orden">
                            <tr>
                                <td style="padding-right: 1rem">
                                    {{ key }}
                                </td>
                                <td v-for="orden in ordenes">
                                    <v-text-field
                                        :readonly="!admin"
                                        v-mask="'##:##'"
                                        v-model="orden.horas"
                                        @change="
                                            editFicha2(
                                                orden.id,
                                                orden.horas,
                                                item.fecha,
                                                item.usuario_id,
                                                orden.orden_id
                                            )
                                        "
                                    ></v-text-field>
                                </td>
                            </tr>
                        </template>
                    </table>
                </td>
            </template>
            <template v-slot:item.fecha="{ item }">
                {{ item.fecha }}
            </template>
            <template
                v-slot:item.data-table-expand="{ item, isExpanded, expand }"
            >
                <template v-if="item.orden">
                    <v-icon @click="expand(true)" v-if="!isExpanded"
                        >mdi-chevron-down</v-icon
                    >
                    <v-icon @click="expand(false)" v-else
                        >mdi-chevron-up</v-icon
                    >
                </template>
            </template>
            <template v-slot:item.hora__0="item">
                <div style="display: flex">
                    <v-text-field
                        v-mask="'##:##'"
                        v-model="item.item.hora_0"
                        @change="
                            editFicha(
                                item.item.id_0,
                                item.item.hora_0,
                                item.item.fecha,
                                item.item.usuario_id
                            )
                        "
                    ></v-text-field>
                    <v-icon
                        @click="deleteFicha(item.item.id_0)"
                        small
                        class="mr-2"
                        color="red"
                    >
                        mdi-trash-can
                    </v-icon>
                </div>
            </template>
            <template
                v-slot:[`item.hora__${num}`]="item"
                v-for="num in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9]"
            >
                <div style="display: flex" v-if="!item.item.vacaciones">
                    <v-text-field
                        v-mask="'##:##'"
                        v-model="item.item[`hora_${num}`]"
                        @change="
                            editFicha(
                                item.item[`id_${num}`],
                                item.item[`hora_${num}`],
                                item.item[`fecha`],
                                item.item[`usuario_id`]
                            )
                        "
                    ></v-text-field>
                    <v-icon
                        @click="deleteFicha(item.item[`id_${num}`])"
                        small
                        class="mr-2"
                        color="red"
                    >
                        mdi-trash-can
                    </v-icon>
                </div>
                <div v-else>
                    <v-text-field value="Vacaciones" readonly></v-text-field>
                </div>
            </template>

            <template v-slot:item.actions="{ item }">
                <template v-if="item.incidencia">
                    <v-icon
                        @click="openIncidenciaDialog(item)"
                        small
                        class="mr-2"
                        color="blue"
                    >
                        mdi-calendar-clock
                    </v-icon>
                </template>
            </template>
        </v-data-table>

        <v-dialog v-model="dialog">
            <form-fichajes v-model="fichaje" @done="refresh()"></form-fichajes>
        </v-dialog>
        <v-dialog v-model="incidencia_dialog">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Incidencias
                </v-card-title>
                <v-card-text style="text-align: center">
                    <v-data-table
                        dense
                        :headers="headers_incidencias"
                        :items="incidencias"
                        item-key="id"
                        class="elevation-1"
                        :sort-by="['nombre']"
                        :sort-desc="[false]"
                    >
                        <template v-slot:item.url_file="{ item }">
                            <a
                                :href="item.url_file"
                                target="__blank"
                                v-if="item.nombre_archivo"
                            >
                                <v-icon
                                    small
                                    class="mr-2"
                                    color="#1d2735"
                                    style="font-size: 25px"
                                    title="Archivo"
                                    >mdi-file</v-icon
                                >
                            </a>
                        </template>
                        <template v-slot:item.fecha_inicio="{ item }">
                            {{ item.fecha_inicio | format_date }}
                        </template>
                        <template v-slot:item.fecha_fin="{ item }">
                            <template v-if="item.fecha_fin">
                                {{ item.fecha_fin | format_date }}
                            </template>
                        </template>
                        <template v-slot:item.justificado="{ item }">
                            {{ item.justificado ? "Si" : "No" }}
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-icon
                                @click="openModalCreate(item)"
                                small
                                class="mr-2"
                                color="#1d2735"
                                style="font-size: 25px"
                                title="EDITAR"
                                >mdi-pencil-outline</v-icon
                            >

                            <v-icon
                                @click="openModal(item)"
                                small
                                class="mr-2"
                                color="red"
                                style="font-size: 25px"
                                title="BORRAR"
                                >mdi-trash-can</v-icon
                            >
                        </template>
                    </v-data-table>
                    <template v-for="incidencia in incidencias">
                        <h5>{{ incidencia.tipo.nombre }}</h5>
                    </template>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="delete_dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            delete_dialog = false;
                            delete_id = null;
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteFichaje()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog_consumo">
            <v-card>
                <v-card-title>Consumos</v-card-title>
                <v-card-text>
                    <v-data-table
                        :items="consumo.consumos"
                        :headers="headers_consumos"
                    >
                        <template v-slot:item.nombre_archivo="{ item }">
                            <a target="_blank" :href="item.url">
                                <img
                                    :src="item.url"
                                    width="auto"
                                    height="60px"
                                />
                            </a>
                        </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import FormFichajes from "./FormFichajes.vue";

export default {
    components: { FormFichajes },
    data() {
        return {
            headers_incidencias: [
                { text: "Fecha inicio", value: "fecha_inicio" },
                { text: "Fecha fin", value: "fecha_fin" },
                { text: "Duración", value: "duracion" },
                { text: "Tipo de incidencia", value: "tipo.nombre" },
                { text: "Justificado", value: "justificado" },
                { text: "Archivo", value: "url_file" },
            ],
            expanded: [],
            incidencias: [],

            delete_dialog: false,
            incidencia_dialog: false,

            delete_id: null,
            headers_consumos: [
                { text: "Tipo", value: "tipo.nombre", sortable: false },

                { text: "Importe", value: "importe", sortable: false },
                { text: "Imagen", value: "nombre_archivo", sortable: false },
            ],
            horas_extra: 0,
            horas_semana: 0,
            horas_trabajadas: 0,
            pago_extra: 0,
            menu: false,
            menu2: false,
            consumo: { total: 0, consumos: [] },
            usuarios: [],
            fichaje: {},
            filtros: {
                fecha_inicio: null,
                fecha_fin: null,
                usuario: null,
            },
            search: "",
            alto: 0,
            fichajes: [],
            rol: "",
            dialog: false,
            dialog_consumo: false,
        };
    },
    created() {
        this.rol = localStorage.getItem("role");
        this.getUsuarios();
        const date = new Date();
        const fecha_inicio = new Date();
        const fecha_fin = new Date();
        this.filtros.fecha_inicio = fecha_inicio.toISOString().slice(0, 10);
        this.filtros.fecha_fin = fecha_fin.toISOString().slice(0, 10);
        if (this.admin) {
            this.filtrar();
        } else {
            this.getFichajesByUser();
        }
    },
    methods: {
        openIncidenciaDialog(item) {
            if (item.incidencia) {
                this.incidencias = item.incidencia;

                console.log(this.incidencias);
                this.incidencia_dialog = true;
            }
        },
        getRowClass(item) {
            if (item.incidencia) {
                return "yellow";
            }
            //return "pointer";
        },
        /*
 'orden_id' => $orden_id,
          'usuario_id'=> $request->user_id?? $user->id,
          'fecha'
        */
        async editFicha2(id, hora, fecha, usuario_id, orden_id) {
            if (this.admin) {
                const fecha_exp = fecha.split("-");
                const fec = `${fecha_exp[2]}-${fecha_exp[1]}-${fecha_exp[0]} ${hora}`;
                let res = await axios.post(`api/fichar-orden/${orden_id}`, {
                    id: id,
                    usuario_id: usuario_id,
                    fecha: fec,
                });
            }
        },
        editFicha(id, hora, fecha, usuario_id) {
            const fecha_exp = fecha.split("-");
            const fec = `${fecha_exp[2]}-${fecha_exp[1]}-${fecha_exp[0]}`;

            axios
                .post(`api/save-fichaje`, {
                    id: id,
                    fecha: fec,
                    hora: hora,
                    usuario_id: usuario_id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Fichaje guardado con éxito");
                        this.fichaje = {};
                        this.$emit("done");
                    },
                    (err) => {
                        this.$toast.error("Error guardando el fichaje");
                    }
                );
        },
        deleteFicha(id) {
            this.delete_id = id;
            this.delete_dialog = true;
        },
        openConsumoModal() {
            this.dialog_consumo = true;
        },
        refresh() {
            this.dialog = false;
            // this.getFichajes();
            this.filtrar();
        },
        getFichajesByUser() {
            axios
                .post(
                    `api/get-fichajes-by-user/${localStorage.getItem(
                        "user_id"
                    )}`,
                    this.filtros
                )
                .then(
                    (res) => {
                        this.fichajes = res.data;
                        this.$toast.success("Fichajes actualizados con éxito");
                    },
                    (err) => {
                        this.$toast.error("Error consultando los fichajes");
                    }
                );
        },
        editFichaje(item) {
            this.fichaje = item;
            this.dialog = true;
        },
        deleteFichaje() {
            axios.get(`api/delete-fichaje/${this.delete_id}`).then(
                (res) => {
                    this.filtrar();
                    this.delete_dialog = false;
                },
                (err) => {
                    this.$toast.error("Error eliminando el fichaje");
                }
            );
        },
        getFichajes() {
            axios.post(`api/get-fichajes`, this.filtros).then(
                (res) => {
                    this.fichajes = res.data.data;
                    //console.log(res.data.data);
                    this.$toast.success("Fichajes actualizados con éxito");
                },
                (err) => {
                    this.$toast.error("Error consultando los fichajes");
                }
            );
        },
        filtrar() {
            if (!this.admin) {
                this.filtros.usuario = localStorage.getItem("user_id");
            }
            axios.post(`api/get-fichajes`, this.filtros).then(
                (res) => {
                    this.fichajes = res.data.parsed;
                    this.alto = res.data.high;
                    this.horas_trabajadas = res.data.count;

                    this.horas_extra = res.data.hora_extra;
                    this.horas_semana = res.data.count - res.data.hora_extra;
                    this.pago_extra = res.data.pago_extra;
                    /*this.pago_extra =
                        this.horas_extra * parseFloat(res.data.hora_extra);*/
                    this.consumo = res.data.consumos;

                    if (this.horas_extra < 0) this.horas_extra = 0;

                    this.$toast.success("Fichajes actualizados con éxito");
                },
                (err) => {
                    this.$toast.error("Error consultando los fichajes");
                }
            );
        },

        crearPDF() {
            if (this.rol != 1) {
                this.filtros.usuario = localStorage.getItem("user_id");
            }
            axios.post(`api/crear-pdf-fichajes`, this.filtros).then(
                (res) => {
                    const url = res.data.url_name;
                    window.open(`storage/fichajes/${url}`, "_blank");
                },
                (err) => {
                    this.$toast.error("Error consultando los fichajes");
                }
            );
        },
        getUsuarios() {
            axios.get(`api/get-empleados-token-fichaje`).then(
                (res) => {
                    this.usuarios = res.data.data;
                    this.usuarios.unshift("");
                },
                (err) => {
                    this.$toast.error("Error consultando los fichajes");
                }
            );
        },
    },
    computed: {
        admin() {
            return (
                this.rol == 1 ||
                this.rol == 2 ||
                this.rol == 9 ||
                this.rol == 14
            );
        },
        headers() {
            let res = [
                {
                    text: "Usuario",
                    value: "nombre",
                    sortable: false,
                },
                {
                    text: "Fecha",
                    value: "fecha",
                    sortable: true,
                },
                /*{
                    text: "Fichaje Orden",
                    value: "orden",
                    sortable: true,
                },*/
            ];

            for (let i = 0; i < this.alto; i++) {
                res.push({
                    text: `Fichaje ${i + 1}`,
                    value: `hora_${this.admin ? "_" : ""}${i}`,
                    sortable: true,
                });
            }
            /*res.push({
                text: "Horas",
                value: "horas",
                sortable: false,
            });*/
            res.push({
                text: "Acciones",
                value: "actions",
                sortable: false,
            });
            res.push({ text: "", value: "data-table-expand" });
            /*res.push({
                text: "Acciones",
                value: "action",
                sortable: false,
            });*/
            return res;
        },
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>
